import { Badge, Flex, Pagination, Table } from "@mantine/core";
import { useEffect, useState } from "react";
import { deleteAdminUserById, getAdminUsersList } from "../../api/adminUserApi";
import { deleteNotification } from "../../utils/useNotification";
import { useAuth } from "../../context/AuthContext";
import { notifications } from "@mantine/notifications";
import { useNavigate } from "react-router";
import TableDeleteButton from "../common/TableDeleteButton";
import TableEditButton from "../common/TableEditButton";
import styled from "styled-components";
import AreYouSureModal from "../common/AreYouSureModal";

const AdminUsersTable = () => {
  const { adminUser: currentUser } = useAuth();
  const navigate = useNavigate();

  const [tableData, setTableData] = useState<any>();
  //for pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);
  const [totalPages, setTotalPages] = useState(1);
  
  //for delete modal
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [itemToDeleteId, setitemToDeleteId] = useState<any>();

  const getTableData = async () => {
    try {
      const { data }: any = await getAdminUsersList({
        pageNumber: page,
        limit: limit,
      });
      setTableData(data?.data);
      setPage(data?.meta?.page);
      setLimit(data?.meta?.limit);
      setTotalPages(data?.meta?.totalPages);
    } catch (error) {}
  };

  const handleDeleteClick = async (id: any) => {
    if (currentUser?._id !== id) {
      try {
        const { data }: any = await deleteAdminUserById({
          id,
        });
        deleteNotification(data?.success);
        getTableData();
        } catch (error) {
        console.error("Silme hatası:", error);
      }
    } else {
      notifications.show({
        title: "Hata",
        message: "Kendi hesabınızı silemezsiniz.",
        color: "red",
        autoClose: 4000,
        withBorder: true,
      });
    }
  };

  useEffect(() => {
    getTableData();
    navigate(`?page=${page}&limit=${limit}`, { replace: true });
  }, [page, limit]);

  return (
    <TableWrapper>
      <div style={{ overflowX: "auto", width: "100%" }}>
          <Table
            style={{
              borderCollapse: "separate",
              borderSpacing: "0px 4px",
            }}
            verticalSpacing="sm"
            withRowBorders={false}
          >
            <Table.Thead>
              <Table.Tr>
                <StyledTableTh style={{ width: "25%" }}>
                  Kullanıcı Adı
                </StyledTableTh>
                <StyledTableTh style={{ width: "30%" }}>Ad Soyad</StyledTableTh>
                <StyledTableTh style={{ width: "25%" }}>Telefon</StyledTableTh>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody style={{ backgroundColor: "#FBFBFB" }}>
              {tableData?.map((item: any) => (
                <Table.Tr
                  style={{
                    color: "#1D1B20",
                    fontSize: "16px",
                    fontWeight: "400",
                  }}
                  bg={"#F9F9F9"}
                  key={item._id}
                >
                  <Table.Td style={{ width: "30%" }}>
                    <Flex justify={"start"} align={"center"} gap={16}>
                      <Badge
                        style={{ cursor: "pointer" }}
                        circle
                        bg={"#EADDFF"}
                        size={"40px"}
                      >
                        <AvatarText>{item.username[0]}</AvatarText>
                      </Badge>
                      {item.username}
                    </Flex>
                  </Table.Td>
                  <Table.Td style={{ width: "25%" }}>{item.name}</Table.Td>
                  <Table.Td style={{ width: "25%" }}>
                    {item.phone}
                  </Table.Td>
                  <Table.Td style={{ width: "10%" }}>
                    <Flex gap={12}>
                      <TableEditButton
                        onClick={() => {
                          navigate(`/admin-users/edit/${item._id}`);
                        }}
                      />
                      <TableDeleteButton
                        onClick={() => {
                          setitemToDeleteId(item?._id);
                          setOpenDeleteModal(true);
                        }}
                      />
                    </Flex>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
      </div>
        <Flex justify="center" style={{ position: "absolute", bottom: "20px", left: "50%", transform: "translateX(-50%)" }}>
          <Pagination
            total={totalPages}
            value={page}
            onChange={setPage}
            withEdges
            color="#5C26FF"
            radius="xl"
          />
        </Flex>
      
      <AreYouSureModal
        opened={openDeleteModal}
        setOpened={setOpenDeleteModal}
        proccessFunc={() => handleDeleteClick(itemToDeleteId)}
        title="Admin Kullanıcısı Sil"
        text="Bu admin kullanıcısını silmek istediğinizden emin misiniz?"
        confirmButtonText="Sil"
        cancelButtonText="Vazgeç"
      />
    </TableWrapper>
  );
};

export default AdminUsersTable;

const StyledTableTh = styled(Table.Th)`
  color: #4c4c4c;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`;

const AvatarText = styled.div`
  color: #21005d;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
`;

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  justify-content: space-between;
`;
